/* eslint-disable class-methods-use-this */
import React from 'react';
import { DOMNode } from 'html-react-parser';
import _ from 'lodash';

export default class contentHelper {
  static decodeHtmlEntities = (content: string) => {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    return doc.documentElement.textContent;
  };

  static parseStyleString(styleString: string): React.CSSProperties {
    if (!styleString) return {};
    return styleString.split(';').reduce((style: React.CSSProperties, rule: string) => {
      const [property, value] = rule.split(':').map((str) => str.trim());
      if (property && value) {
        // Convert CSS property names to camelCase
        const camelProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        // Use type assertion to handle React's strict CSS property types
        (style as any)[camelProperty] = value;
      }
      return style;
    }, {});
  }

  static humanize = (text: string) => {
    return text
      .split(/[_\s-]/) // Split on underscores, spaces, and hyphens
      .map((word) => {
        // Special case for "id"
        if (/\bid\b/i.test(word)) return word.toUpperCase();

        // If the word is all caps, convert to title case
        if (word === word.toUpperCase()) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }

        // Otherwise, just capitalize the first letter
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  static parameterize = (text: string) => {
    return text
      .trim()
      .toLowerCase()
      .replace(/[^a-zA-Z0-9 -]/, '')
      .replace(/\s/g, '-');
  };
}
